import { z } from 'zod';

// Mirrors the backend default page size.
export const DEFAULT_LIMIT = 20;
export const LIMIT_OPTIONS = [10, 20, 50, 100] as const;

/**
 * Search params every cursor-paginated list route validates with `validateSearch`.
 * Extend per route: `cursorSearchSchema.extend({ status: z.enum([...]).optional() })`.
 * The backend orders lists itself and exposes no `sort` parameter.
 */
export const cursorSearchSchema = z.object({
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(100).optional(),
  q: z.string().optional(),
});

export type CursorSearch = z.infer<typeof cursorSearchSchema>;

export interface SortState {
  field: string;
  direction: 'asc' | 'desc';
}

export function parseSort(sort: string | undefined): SortState | null {
  if (!sort) return null;
  return sort.startsWith('-')
    ? { field: sort.slice(1), direction: 'desc' }
    : { field: sort, direction: 'asc' };
}

/** Click cycle: none → asc → desc → none. */
export function toggleSort(current: string | undefined, field: string): string | undefined {
  const parsed = parseSort(current);
  if (parsed?.field !== field) return field;
  if (parsed.direction === 'asc') return `-${field}`;
  return undefined;
}
